<template>
  <div class="project-list-container">
    <div class="project-list-card">
      <div class="card-header">
        <h2>项目列表</h2>
        <div class="header-actions">
          <router-link to="/app/projects/create" class="action-btn primary" v-if="authority === '1' || authority === '2'">➕ 添加项目</router-link>
<!--           <button @click="fetchProjects" :disabled="loading" class="action-btn">
            {{ loading ? '刷新中...' : '🔄 刷新' }}
          </button>-->
        </div>
      </div>
      <!-- 查询栏 -->
      <div class="search-bar">
        <el-select v-model="searchName" filterable placeholder="请输入项目名称" :filter-method="filterProjectName">
          <el-option v-for="item in filteredProjectNames" :key="item" :label="item" :value="item" />
        </el-select>
<!--        <select v-model="searchStatus" class="search-select">
          <option value="">全部状态</option>
          <option value="在线">在线</option>
          <option value="离线">离线</option>
        </select>-->
        <el-select v-model="searchStatus" placeholder="请选择状态">
          <el-option label="全部状态" value=""></el-option>
          <el-option label="在线" value="1"></el-option>
          <el-option label="离线" value="2"></el-option>
        </el-select>

        <button class="action-btn primary" @click="onSearch">查询</button>
      </div>
      <div v-if="loading" class="loading-tip">正在加载...</div>
      <div v-if="error" class="error-tip">{{ error }}</div>
      <!-- 桌面端表格 -->
      <div class="table-container desktop-table" v-if="!loading && !error">
        <table>
          <thead>
            <tr>
              <th>序号</th>
              <th>项目名称</th>
              <th>项目描述</th>
              <th>状态</th>
              <th>媒体状态</th>
              <th>项目类别</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="projects.length === 0">
              <td colspan="6">暂无数据</td>
            </tr>
            <tr v-for="(project, index) in projects" :key="project.id || index">
              <td>{{ index + 1 }}</td>
              <td>{{ project.name }}</td>
              <td>{{ project.description }}</td>
              <td>
                <span :class="['status-badge', getStatusClass(project.status)]">
                  {{ project.status == 1 ? '在线' : project.status == 2 ? '离线' : project.status }}
                </span>
              </td>
              <td>
                <span :class="['status-badge1', getMediaStatusClass(project.mediaStatus)]">
                  {{ project.mediaStatus == 1 ? '显示' : project.mediaStatus == 0 ? '不显示' : project.mediaStatus }}
                </span>
              </td>
              <td>
                <span v-if="project.type == 1" style="background:#ff4d4f;color:#fff;padding:2px 10px;border-radius:4px;">A类</span>
                <span v-else-if="project.type == 2" style="background:#1890ff;color:#fff;padding:2px 10px;border-radius:4px;">B类</span>
                <span v-else>{{ project.type}}</span>
              </td>
              <td>
                <button class="action-btn" @click="openEditDialog(project)">编辑</button>
                <button class="action-btn danger" @click="openDeleteDialog(project)">删除</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <!-- 移动端卡片列表 -->
      <div class="mobile-project-list" v-if="!loading && !error">
        <div v-if="projects.length === 0" class="empty-card">
          <div class="empty-content">暂无数据</div>
        </div>
        <div v-else>
          <div v-for="(project, index) in projects" :key="project.id || index" class="project-card">
            <div class="project-card-header">
              <span class="card-index">#{{ index + 1 }}</span>
              <span class="card-name">{{ project.name }}</span>
            </div>
            <div class="card-content">
              <div class="info-row">
                <span class="label">描述：</span>
                <span class="value">{{ project.description || '无描述' }}</span>
              </div>
              <div class="info-row">
                <span class="label">状态：</span>
                <span class="value">
                  <span :class="['status-badge', getStatusClass(project.status)]">
                    {{ project.status == 1 ? '在线' : project.status == 2 ? '离线' : project.status }}
                  </span>
                </span>
              </div>
              <div class="info-row">
                <span class="label">状态：</span>
                <span class="value">
                  <span :class="['status-badge1', getMediaStatusClass(project.mediaStatus)]">
                    {{ (project.mediaStatus == 0 || project.mediaStatus == null) ? '不显示' : project.mediaStatus == 1 ? '显示' : project.mediaStatus }}
                  </span>
                </span>
              </div>
              <div class="info-row">
                <span class="label">类别：</span>
                <span class="value">
                  <span v-if="project.type == 1" style="background:#ff4d4f;color:#fff;padding:2px 10px;border-radius:4px;">A类</span>
                  <span v-else-if="project.type == 2" style="background:#1890ff;color:#fff;padding:2px 10px;border-radius:4px;">B类</span>
                  <span v-else>{{ project.type}}</span>
                </span>
              </div>
            </div>
            <div class="card-actions">
              <el-button size="mini" type="primary" @click="openEditDialog(project)">编辑</el-button>
              <el-button size="mini" type="danger" @click="openDeleteDialog(project)">删除</el-button>
            </div>
          </div>
        </div>
      </div>

      <div class="table-pagination-bar">
        <span class="table-count-bottom">
          共{{ total }}条数据 | 第{{ page }} / {{ totalPages }}页
        </span>
        <button class="page-arrow" :disabled="page <= 1" @click="goPrevPage">
          <i class="el-icon-arrow-left"></i>
        </button>
        <button class="page-arrow" :disabled="page >= totalPages" @click="goNextPage">
          <i class="el-icon-arrow-right"></i>
        </button>
        </div>
      <!-- 编辑弹窗 -->
      <div v-if="showEditDialog" class="dialog-mask">
        <div class="dialog-box">
          <h3>编辑项目</h3>
          <form @submit.prevent="submitEdit">
            <div class="form-group">
              <label>项目名称</label>
              <input v-model="editForm.name" type="text" required />
            </div>
            <div class="form-group">
              <label>项目描述</label>
              <textarea v-model="editForm.description" rows="3"></textarea>
            </div>
            <div class="form-group">
              <label>项目状态</label>
              <select v-model="editForm.status" required>
                <option value="1">在线</option>
                <option value="2">离线</option>
              </select>
            </div>
            <div class="form-group">
              <label>媒体状态</label>
              <select v-model="editForm.mediaStatus" required>
                <option value="1" label="显示">显示</option>
                <option value="0" label="不显示">不显示</option>
              </select>
            </div>
            <div class="form-group">
              <label>项目类别</label>
              <select v-model="editForm.type" required>
                <option value="1">A类项目</option>
                <option value="2">B类项目</option>
              </select>
            </div>
            <div class="dialog-actions">
              <button type="submit" class="action-btn primary" :disabled="editLoading">{{ editLoading ? '提交中...' : '提交' }}</button>
              <button type="button" class="action-btn" @click="showEditDialog = false">取消</button>
            </div>
            <div v-if="editError" class="edit-error">{{ editError }}</div>
            <div v-if="editSuccess" class="edit-success">{{ editSuccess }}</div>
          </form>
        </div>
      </div>
      <!-- 删除确认弹窗 -->
      <div v-if="showDeleteDialog" class="dialog-mask">
        <div class="dialog-box">
          <h3>删除确认</h3>
          <div class="delete-tip">确定要删除项目「{{ deleteTarget?.name }}」吗？</div>
          <div class="dialog-actions">
            <button class="action-btn danger" @click="confirmDelete" :disabled="deleteLoading">{{ deleteLoading ? '删除中...' : '删除' }}</button>
            <button class="action-btn" @click="showDeleteDialog = false" :disabled="deleteLoading">取消</button>
          </div>
          <div v-if="deleteError" class="edit-error">{{ deleteError }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ProjectList',
  data() {
    return {
      projects: [],
      loading: false,
      error: null,
      showEditDialog: false,
      editForm: {
        id: '',
        name: '',
        description: '',
        status: '在线',
        type: 1,
        mediaStatus: '1'
      },
      editLoading: false,
      editError: '',
      editSuccess: '',
      showDeleteDialog: false,
      deleteTarget: null,
      deleteLoading: false,
      deleteError: '',
      page: 1,
      total: 0,
      totalPages: 1,
      searchName: '全部',
      searchStatus: '',
      isSearched: false,
      allProjectNames: [],
      projectNameFilter: '',
      authority: ''
    };
  },
  created() {
    this.fetchProjects();
    this.fetchAllProjectNames();
  },
  methods: {
    async fetchProjects(page = 1) {
      this.loading = true;
      this.error = null;
      this.page = page;
      
      // 获取token
      const token = localStorage.getItem('token');
      if (!token) {
        this.error = '未找到用户认证信息，请重新登录';
        this.loading = false;
        return;
      }

      try {
        // 首先获取用户信息
        const userInfoRes = await axios.get('/api/user/info');
        const userInfo = userInfoRes.data;
        this.authority = userInfo.authority;
        const employeeId = userInfo.employeeId;
        
        // 判断是否有查询条件
        if (this.isSearched || this.searchName || this.searchStatus) {
          // 查询接口
          const name = this.searchName == "全部" ? "" : this.searchName;
          let url;
          if (this.authority == 1) {
            // 管理员可以查看所有项目
            url = `/api/projects/search?name=${encodeURIComponent(name)}&status=${encodeURIComponent(this.searchStatus)}&mediaStatus=&page=${page}`;
          } else {
            // 普通员工只能查看自己的项目
            url = `/api/projects/searchWithEmployee?name=${encodeURIComponent(name)}&status=${encodeURIComponent(this.searchStatus)}&mediaStatus=&employeeId=${encodeURIComponent(employeeId)}&page=${page}`;
          }
          const response = await axios.get(url);
          this.projects = response.data.data || [];
          this.total = response.data.total || 0;
          this.totalPages = response.data.totalPages || 1;
          console.log(this.projects);
          this.projects = this.projects.map(p => {
            return {
              ...p,
              mediaStatus: p.mediaStatus === null ? 0 : p.mediaStatus
            }
          });
          console.log(this.projects);
        } else {
          // 默认接口
          let url;
          if (this.authority == 1) {
            url = `/api/projects/search?name=&status=&mediaStatus=&page=${page}`;
          } else {
            url = `/api/projects/searchWithEmployee?name=&status=&mediaStatus=&employeeId=${encodeURIComponent(employeeId)}&page=${page}`;
          }
          const response = await axios.get(url);
          this.projects = response.data.data || [];
          console.log(this.projects);
          this.projects = this.projects.map(p => {
            return {
              ...p,
              mediaStatus: p.mediaStatus === null ? 0 : p.mediaStatus
            }
          });
          console.log(this.projects);
          this.total = response.data.total || 0;
          this.totalPages = response.data.totalPages || 1;
        }
      } catch (err) {
        this.error = '无法加载项目列表，请稍后重试。';
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    onSearch() {
      this.isSearched = true;
      this.fetchProjects(1);
    },
    goPrevPage() {
      if (this.page <= 1) return;
      this.fetchProjects(this.page - 1);
    },
    goNextPage() {
      if (this.page >= this.totalPages) return;
      this.fetchProjects(this.page + 1);
    },
    getStatusClass(status) {
      let num = Number(status); 
      if (num === 1) {
        return 'status-online';
      }
      if (num === 2) {
        return 'status-offline';
      }
      return 'status-default';
    },
    getMediaStatusClass(status) {
      let num = Number(status);
      if (num === 1) {
        return 'status-online1';
      }
      if (num === 0) {
        return 'status-offline';
      }
      return 'status-default';
    },

    openEditDialog(project) {
      this.editForm = { ...project };
      console.log(this.editForm);
      this.editError = '';
      this.editSuccess = '';
      this.showEditDialog = true;
    },
    async submitEdit() {
      this.editError = '';
      this.editSuccess = '';
      this.editLoading = true;
      
      // 获取token
      const token = localStorage.getItem('token');
      if (!token) {
        this.editError = '未找到用户认证信息，请重新登录';
        this.editLoading = false;
        return;
      }

      try {
        await axios.post('/api/projects/update', {
          id: this.editForm.id,
          name: this.editForm.name,
          description: this.editForm.description,
          status: this.editForm.status,
          mediaStatus: this.editForm.mediaStatus,
          type: this.editForm.type
        });
        this.editSuccess = '修改成功！';
        this.fetchProjects(this.page);
        setTimeout(() => {
          this.showEditDialog = false;
        }, 1000);
      } catch (e) {
        this.editError = '提交失败，请稍后重试';
      } finally {
        this.editLoading = false;
      }
    },
    openDeleteDialog(project) {
      this.deleteTarget = project;
      this.deleteError = '';
      this.showDeleteDialog = true;
    },
    async confirmDelete() {
      if (!this.deleteTarget) return;
      this.deleteLoading = true;
      this.deleteError = '';
      
      // 获取token
      const token = localStorage.getItem('token');
      if (!token) {
        this.deleteError = '未找到用户认证信息，请重新登录';
        this.deleteLoading = false;
        return;
      }

      try {
        await axios.post('/api/projects/delete', { id: this.deleteTarget.id });
        this.showDeleteDialog = false;
        this.fetchProjects(this.page);
      } catch (e) {
        this.deleteError = '删除失败，请稍后重试';
      } finally {
        this.deleteLoading = false;
      }
    },
    async fetchAllProjectNames() {
      try {
        // 首先获取用户信息
        const token = localStorage.getItem('token');
        if (!token) {
          console.error('未找到用户token');
          this.allProjectNames = ["全部"];
          return;
        }

        // 获取用户信息
        const userInfoRes = await axios.get('/api/user/info');
        const userInfo = userInfoRes.data;
        
        // 根据用户权限获取项目列表
        this.authority = userInfo.authority;
        const employeeId = userInfo.employeeId;
        
        let url;
        if (this.authority == 1) {
          // 管理员可以查看所有项目
          url = '/api/projects';
        } else {
          // 普通员工只能查看自己的项目
          url = `/api/projects/byEmployee?employeeId=${employeeId}`;
        }
        
        const projectsRes = await axios.get(url);
        this.allProjectNames = (projectsRes.data.data || []).map(p => p.name);
        
        // 判断是否包含"全部"，如果没有就添加
        if (!this.allProjectNames.includes("全部")) {
          this.allProjectNames.unshift("全部"); // 放在最前面
        }
      } catch (e) {
        console.error('获取项目名称列表失败:', e);
        this.allProjectNames = ["全部"];
      }
    },
    filterProjectName(query) {
      this.projectNameFilter = query;
    },
  },
  computed: {
    filteredProjectNames() {
      if (!this.projectNameFilter) return this.allProjectNames;
      return this.allProjectNames.filter(
        name => name.toLowerCase().includes(this.projectNameFilter.toLowerCase()));
    },

  }
};
</script>

<style scoped>
.project-list-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  /* background-color: #f0f2f5; */
  padding-top: 20px;
  box-sizing: border-box;
}

.project-list-card {
  width: 100%;
  max-width: 1000px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 24px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e8e8e8;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.card-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.action-btn {
  background-color: #fff;
  color: #444;
  border: 1px solid #dcdfe6;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}
.action-btn:hover {
  border-color: #40a9ff;
  color: #40a9ff;
}

.action-btn.primary {
  background-color: #1890ff;
  color: white;
  border-color: #1890ff;
}
.action-btn.primary:hover {
  background-color: #40a9ff;
  border-color: #40a9ff;
  color: white;
}

.action-btn:disabled {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}

.loading-tip, .error-tip {
  text-align: center;
  padding: 40px;
  font-size: 16px;
  color: #888;
}

.error-tip {
  color: #f5222d;
}

.table-container {
  overflow-x: auto;
  align: center;
  text-align: center;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

th, td {
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
  text-align: center;
}

th {
  background-color: #fafafa;
  font-weight: 500;
  color: #333;
}

tbody tr:hover {
  background-color: #f5f5f5;
}

td:first-child {
  width: 80px;
  text-align: center;
}

.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  text-align: center;
}

.status-badge1 {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  text-align: center;
}

.status-online1 {
  background-color: #c709e4; /* Green */
}

.status-online {
  background-color: #52c41a; /* Green */
}

.status-offline {
  background-color: #f5222d; /* Red */
}

.status-default {
  background-color: #bfbfbf; /* Gray */
}



.action-btn.danger {
  background-color: #fff1f0;
  color: #f5222d;
  border-color: #ffa39e;
}
.action-btn.danger:hover {
  background-color: #ffccc7;
  color: #a8071a;
  border-color: #ff7875;
}

.dialog-mask {
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.18);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-box {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.13);
  padding: 32px 28px 24px 28px;
  min-width: 320px;
  max-width: 90vw;
}
.dialog-box h3 {
  margin: 0 0 18px 0;
  font-size: 20px;
  color: #333;
  text-align: center;
}
.form-group {
  margin-bottom: 18px;
}
.form-group label {
  display: block;
  margin-bottom: 6px;
  color: #333;
  font-size: 15px;
}
.form-group input, .form-group select, .form-group textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 15px;
  box-sizing: border-box;
  transition: border-color 0.2s;
}
.form-group input:focus, .form-group select:focus, .form-group textarea:focus {
  border-color: #1890ff;
  outline: none;
}
.dialog-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 10px;
}
.edit-error {
  color: #ff4d4f;
  text-align: center;
  margin-top: 10px;
  font-size: 14px;
}
.edit-success {
  color: #52c41a;
  text-align: center;
  margin-top: 10px;
  font-size: 14px;
}
.delete-tip {
  color: #f5222d;
  font-size: 16px;
  text-align: center;
  margin-bottom: 18px;
}
.table-pagination-bar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 8px;
  gap: 8px;
  width: 100%;
}
.table-count-bottom {
  color: #888;
  font-size: 15px;
  min-width: 180px;
  text-align: right;
}
.page-arrow {
  border: none;
  background: none;
  font-size: 18px;
  color: #42b983;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 0.2s;
}
.page-arrow:disabled {
  color: #ccc;
  cursor: not-allowed;
  background: none;
}
.page-arrow:not(:disabled):hover {
  background: #e6f7f1;
}


.search-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}


.search-input {
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 15px;
  width: 180px;
}
.search-select {
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 15px;
  width: 120px;
}

/* 移动端响应式样式 */
@media (max-width: 768px) {
  .project-list-container {
    padding: 16px;
  }
  
  .project-list-card {
    padding: 16px;
  }
  
  .project-list-card .card-header {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
  
  .project-list-card .card-header h2 {
    font-size: 18px;
    text-align: center;
  }
  
  .header-actions {
    justify-content: center;
  }
  
  .header-actions .action-btn {
    width: 100%;
    justify-content: center;
  }
  
  /* 查询栏移动端优化 */
  .search-bar {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  
  .search-bar .el-select {
    width: 100% !important;
  }
  
  .search-bar .action-btn {
    width: 100%;
    justify-content: center;
  }
  
  /* 桌面端表格隐藏 */
  .desktop-table {
    display: none;
  }
  
  /* 移动端卡片显示 */
  .mobile-project-list {
    display: block;
  }
  
  .empty-card {
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    padding: 24px;
    text-align: center;
    margin-bottom: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .empty-content {
    color: #666;
    font-size: 14px;
  }
  
  .project-card {
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    margin-bottom: 12px;
    padding: 16px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .project-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
  }
  
  .card-index {
    background: #1890ff;
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: bold;
  }
  
  .card-name {
    font-weight: bold;
    color: #333;
    font-size: 16px;
  }
  
  .card-content {
    margin-bottom: 12px;
  }
  
  .info-row {
    display: flex;
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 1.4;
  }
  
  .info-row .label {
    color: #666;
    min-width: 60px;
    flex-shrink: 0;
  }
  
  .info-row .value {
    color: #333;
    flex: 1;
    word-break: break-all;
  }
  
  .card-actions {
    text-align: center;
    padding-top: 8px;
    border-top: 1px solid #f0f0f0;
    display: flex;
    gap: 8px;
    justify-content: center;
  }
  
  /* 分页器移动端优化 */
  .table-pagination-bar {
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px;
    overflow-x: auto;
    padding: 8px 0;
  }
  
  .table-count-bottom {
    text-align: center;
    min-width: auto;
  }
}

/* 桌面端隐藏移动端卡片 */
@media (min-width: 769px) {
  .mobile-project-list {
    display: none;
  }
  
  .desktop-table {
    display: block;
  }
}
</style> 